import { PurchaseOrderDetailSlidein } from '@/components/accounts-payable/purchase-order-detail/purchase-order-detail-slidein';
import { useNavigate, useParams } from '@tanstack/react-router';

export function Route() {
  const { purchaseOrderId } = useParams({
    from: '/authenticated/accounts-payable/purchase-orders/$purchaseOrderId',
  });
  const navigate = useNavigate();

  return (
    <PurchaseOrderDetailSlidein
      purchaseOrderId={purchaseOrderId}
      isOpen
      onOpenChange={() => {
        navigate({
          to: '..',
          search: true,
          viewTransition: true,
        });
      }}
    />
  );
}
